module.exports = __webpack_public_path__ + "static/media/vegitables_66.e73dfe4e.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_66.csv
// module id = 653
// module chunks = 0